import { css } from "../../../../../styled-system/css";
import { CustomTriggerTooltip } from "../../basic/Tooltip";

const AssetOverflowTooltip = ({ text, onClick }) => {
  return (
    <div
      className={css({ cursor: "pointer", overflow: "hidden" })}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      {text.length > 12 ?
        <CustomTriggerTooltip toolTip={text} placement="top">
          <div
            className={css({
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "#333",
              flex: "1 1 auto",
            })}
          >
            {text}
          </div>
        </CustomTriggerTooltip>
      : <div
          className={css({
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "#333",
            flex: "1 1 auto",
          })}
          data-for={text}
          data-tip={text}
        >
          {text}
        </div>
      }
    </div>
  );
};

export default AssetOverflowTooltip;
